import React, { FC, Suspense, useEffect, useRef } from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import { SKLanding } from './SwapKiwi/Landing';
import { Provider } from 'react-redux';
import { store } from '../ducks/store';
import { Layout } from './SwapKiwi/Layout';
import { YourNFTs } from './SwapKiwi/YourNFTs/';
import { OpenSwaps } from './SwapKiwi/OpenSwaps';
import { RecentSwaps } from './SwapKiwi/RecentSwaps';
import { RecentSwapDetails } from './SwapKiwi/RecentSwapDetails';
import { Routes } from '../constants/routes';
import { ResolveSwap } from './SwapKiwi/ResolveSwap';
import { AuthorizationRoute, PrivateRoute } from '../containers';
import { useEagerConnect } from '../hooks/web3/useEagerConnect';
import { CreateSwap } from './SwapKiwi/CreateSwap';
import { CreateSwapConfirm } from './SwapKiwi/CreateSwapConfirm';
import { TermsOfUse } from './TermsOfUse';
import { PrivacyPolicy } from './PrivacyPolicy';
import { UnsupportedNetworkModal } from '../components/UnsupportedNetwork';
import { useWeb3React } from '@web3-react/core';
import { About } from './SwapKiwi/About';
import { SKFaq } from './SwapKiwi/FAQ';
import { SKPublicRecentSwaps } from './SwapKiwi/PublicRecentSwaps';
export const App: FC = () => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const triedEager = useEagerConnect();
  // TODO: use loading until tried eager is true
  const { chainId, account } = useWeb3React();
  const prevChainId = useRef<number | null>(null);
  const prevAccount = useRef<string | null | undefined>(null);

  useEffect(() => {
    if (chainId !== undefined) {
      if (prevChainId.current === null) prevChainId.current = chainId;
      else if (prevChainId.current !== chainId) window.location.reload();
    }
  }, [chainId]);
  useEffect(() => {
    if (account !== undefined) {
      if (prevAccount.current === null) prevAccount.current = account;
      else if (prevAccount.current !== account) window.location.reload();
    }
  }, [account]);

  return (
    <Suspense fallback={null}>
      <BrowserRouter>
        <Provider store={store}>
          <Layout>
            <UnsupportedNetworkModal />
            <Switch>
              <AuthorizationRoute exact path={Routes.LANDING_ROUTE}>
                <SKLanding />
              </AuthorizationRoute>
              <PrivateRoute exact path={Routes.YOUR_NFTS} redirectTo={Routes.LANDING_ROUTE}>
                <YourNFTs />
              </PrivateRoute>
              <PrivateRoute exact path={Routes.RESOLVE_SWAP} redirectTo={Routes.LANDING_ROUTE}>
                <ResolveSwap />
              </PrivateRoute>
              <PrivateRoute exact path={Routes.CREATE_SWAP} redirectTo={Routes.LANDING_ROUTE}>
                <CreateSwap />
              </PrivateRoute>
              <PrivateRoute exact path={Routes.CREATE_SWAP_CONFIRM} redirectTo={Routes.LANDING_ROUTE}>
                <CreateSwapConfirm />
              </PrivateRoute>
              <PrivateRoute exact path={Routes.OPEN_SWAPS} redirectTo={Routes.LANDING_ROUTE}>
                <OpenSwaps />
              </PrivateRoute>
              <PrivateRoute exact path={Routes.RECENT_SWAPS} redirectTo={Routes.LANDING_ROUTE}>
                <RecentSwaps />
              </PrivateRoute>
              <PrivateRoute exact path={Routes.RECENT_SWAP_DETAILS} redirectTo={Routes.LANDING_ROUTE}>
                <RecentSwapDetails />
              </PrivateRoute>
              <Route exact path={Routes.TERMS_OF_USE}>
                <TermsOfUse />
              </Route>
              <Route exact path={Routes.PRIVACY_POLICY}>
                <PrivacyPolicy />
              </Route>
              <Route exact path={Routes.ABOUT}>
                <About />
              </Route>
              <Route exact path={Routes.FAQ}>
                <SKFaq />
              </Route>
              <Route exact path={Routes.PUBLIC_RECENT_SWAPS}>
                <SKPublicRecentSwaps />
              </Route>
            </Switch>
          </Layout>
        </Provider>
      </BrowserRouter>
    </Suspense>
  );
};
